module.exports = __webpack_public_path__ + "img/High.aec6d935.png";